import { transformCreditsAutoRechargeConfig } from '@/common/integrations/menhir/employee/credits/credits.dto';
import {
  TMealConfiguration,
  TMenhirMealConfiguration,
} from '@/common/integrations/menhir/employee/meal/meal.types';
import { transformPaymentMethod } from '@/common/integrations/menhir/employee/payments/payments.dto';

export function transformMealConfiguration(
  mealConfiguration: TMenhirMealConfiguration
): TMealConfiguration {
  return {
    autoRecharge: mealConfiguration.auto_recharge
      ? transformCreditsAutoRechargeConfig(mealConfiguration.auto_recharge)
      : null,
    singleTransaction: mealConfiguration.single_transaction
      ? {
          paymentMethod: transformPaymentMethod(
            mealConfiguration.single_transaction.payment_method
          ),
        }
      : null,
  };
}
